import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-externallink",
  "use": "icon-externallink-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-externallink\"><path d=\"M719.189333 207.189333L576 64h384v384L809.728 297.728 545.621333 561.834667l-90.453333-90.538667 264.021333-264.106667zM192 960H64V64h384v128h-256v640h640v-256h128v384h-768z\" fill=\"#1677FF\" p-id=\"2290\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol